import React, { useEffect, useState } from 'react';
import { Skeleton, useMediaQuery } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { getRandomIntInclusive } from "../../../../config/values";

function SwiperSlider({
                          data = [],
                          renderSlide,
                          spaceBetween = 10,
                          slidesPerView = 1,
                          breakpoints = {},
                          showNavigation = false,
                          showPagination = false,
                          disablePaginationOnMobile = false,
                          disableNavigationOnMobile = false,
                          autoplay = false,
                          autoplaySpeed = 3000,
                          loop = false,
                      }) {
    const random = getRandomIntInclusive(1, 999999999999);
    const [shouldShowNavigation, setShouldShowNavigation] = useState(showNavigation);

    const isMobileOrTablet = useMediaQuery((theme) => theme.breakpoints.down('md'));

    const checkNavigation = () => {
        setTimeout(() => {
            const swiper = document.querySelector(`.raya-swiper-${random}`)?.swiper;
            if (swiper) {
                const currentSlidesPerView = Math.ceil(swiper.slidesPerViewDynamic());
                setShouldShowNavigation(data.length > currentSlidesPerView && !!showNavigation);
            }
        }, 100);
    };

    useEffect(() => {
        if(slidesPerView === "auto"){
            checkNavigation();
            window.addEventListener('resize', checkNavigation);
            return () => window.removeEventListener('resize', checkNavigation);
        }

    }, [data.length, random, showNavigation]);

    const shouldDisableNavigation = disableNavigationOnMobile && isMobileOrTablet;
    return (
        <div style={{ position: "relative" }}>
            {shouldShowNavigation && !shouldDisableNavigation && (
                <>
                    <button className={`raya-swiper-arrow raya-swiper-prev raya-swiper-prev-${random}`}>
                        <ChevronLeft size={24} />
                    </button>
                    <button className={`raya-swiper-arrow raya-swiper-next raya-swiper-next-${random}`}>
                        <ChevronRight size={24} />
                    </button>
                </>
            )}

            <Swiper
                className={`raya-swiper-${random}`}
                modules={[
                    ...(showNavigation && !shouldDisableNavigation ? [Navigation] : []),
                    ...(showPagination && !(disablePaginationOnMobile && isMobileOrTablet) ? [Pagination] : []),
                    ...(autoplay ? [Autoplay] : []),
                ]}
                spaceBetween={spaceBetween}
                slidesPerView={slidesPerView}
                breakpoints={breakpoints}
                navigation={
                    shouldShowNavigation && !shouldDisableNavigation
                        ? { prevEl: `.raya-swiper-prev-${random}`, nextEl: `.raya-swiper-next-${random}` }
                        : false
                }
                pagination={showPagination && !(disablePaginationOnMobile && isMobileOrTablet) ? { clickable: true } : false}
                autoplay={autoplay ? { delay: autoplaySpeed, disableOnInteraction: false } : false}
                loop={loop}
                style={showPagination && !(disablePaginationOnMobile && isMobileOrTablet) ? { paddingBottom: 35 } : null}
            >
                {data.length > 0 ? (
                    data.map((item, index) => (
                        <SwiperSlide key={index}>
                            {renderSlide ? renderSlide(item) : <div>No Render Function Provided</div>}
                        </SwiperSlide>
                    ))
                ) : (
                    "nothing to show"
                )}
            </Swiper>
        </div>
    );
}

export default SwiperSlider;